import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-flag-dk",
  "use": "icon-flag-dk-usage",
  "viewBox": "0 0 1568 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1568 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-flag-dk\"><defs><style type=\"text/css\"></style></defs><path d=\"M0.032 0h1556.48v1024H0.032z\" fill=\"#C90C31\" p-id=\"4659\" /><path d=\"M1556.512 421.792H619.936V0H440.032v421.792H0v180.416H440.032V1024h179.904V602.208h936.576z\" fill=\"#F5F7FA\" p-id=\"4660\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/flag-dk.svg
// module id = Dsds
// module chunks = 24